<template>
  <v-footer absolute class="pa-5">
    <ui-button outlined v-if="canCancel" :to="{ name: 'dashboard' }">
      {{ $t("message.common.cancel") }}
    </ui-button>
    <div class="flex-grow-1"></div>
    <div class="d-flex align-center">
      <slot></slot>
    </div>
  </v-footer>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "WizardFooter",
  computed: {
    ...mapState({
      companies: state => state.company.companies
    }),
    ...mapGetters({
      isWizardCompleted: "company/isWizardCompleted",
      canAddCompany: "company/isWizardCompleted"
    }),
    canCancel() {
      return (
        this.companies.length && this.isWizardCompleted && this.canAddCompany
      );
    }
  }
};
</script>
